<!-- Menus are wrapped in ng-template for lazy loading menu content -->

<!-- Menu trigger -->
<button mat-icon-button [matMenuTriggerFor]="AreaOptionsMenu" [disabled]="disabled">
  <mat-icon>more_vert</mat-icon>
</button>

<!-- Main menu -->
<mat-menu #AreaOptionsMenu="matMenu">
  <ng-template matMenuContent>

    <button mat-menu-item
      *ngIf="config.edit"
      (click)="edit(area)"
      [disabled]="!authService.canUpdate('area')">
      <mat-icon>mode_edit</mat-icon>
      {{ 'edit' | translate }}
    </button>

    <mat-divider
      *ngIf="config.edit && config.delete">
    </mat-divider>

    <button mat-menu-item
      *ngIf="config.delete"
      (click)="delete(area)"
      [disabled]="!authService.canDelete('area')">
      <mat-icon>delete</mat-icon>
      {{ 'delete' | translate: 'plural' }}
    </button>

  </ng-template>
</mat-menu>
